// src/router.jsx
import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Bots from "./pages/Bots";
import BotDetail from "./pages/BotDetail";
import Connections from "./pages/Connections";
import Account from "./pages/Account";
import Billing from "./pages/Billing";
import FluxVisualizer from "./components/flux/FluxVisualizer";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Welcome from "./pages/Welcome";
import TemplateSelection from "./pages/TemplateSelection";
import BotCreationWizard from "./pages/BotCreationWizard";

// Función para verificar si el usuario está autenticado
const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

// Componente para rutas protegidas
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Componente para rutas de autenticación
const AuthRoute = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

// Configuración de rutas de la aplicación
const router = createBrowserRouter([
  // Rutas de autenticación
  {
    path: "/login",
    element: <AuthRoute><Login /></AuthRoute>
  },
  {
    path: "/register",
    element: <AuthRoute><Register /></AuthRoute>
  },
  {
    path: "/welcome",
    element: <ProtectedRoute><Welcome /></ProtectedRoute>
  },
  
  // Rutas para la creación de bots
  {
    path: "/templates",
    element: <ProtectedRoute><TemplateSelection /></ProtectedRoute>
  },
  {
    path: "/bot-creation",
    element: <ProtectedRoute><BotCreationWizard /></ProtectedRoute>
  },
  {
    path: "/bot-creation/:templateId",
    element: <ProtectedRoute><BotCreationWizard /></ProtectedRoute>
  },
  
  // Rutas de la aplicación (protegidas)
  {
    path: "/",
    element: <ProtectedRoute><Layout /></ProtectedRoute>,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />
      },
      {
        path: "dashboard",
        element: <Dashboard />
      },
      {
        path: "bots",
        element: <Bots />
      },
      {
        path: "bots/:botId",
        element: <BotDetail />
      },
      {
        path: "connections",
        element: <Connections />
      },
      {
        path: "account",
        element: <Account />
      },
      {
        path: "billing",
        element: <Billing />
      },
      {
        path: "flux/:botId?",
        element: <FluxVisualizer />
      }
    ]
  },
  
  // Ruta catch-all para redirigir al login
  {
    path: "*",
    element: <Navigate to="/login" replace />
  }
]);

export default router;